import UAParser from 'ua-parser-js'

const uaParseResult = new UAParser().getResult()
const defaultValue = 'unknown'

export const getSystemAndVersion = () => {
  const { os } = uaParseResult
  if (!os || !os.name) return defaultValue

  return `${os.name} ${os.version}`
}

export const getBrandAndModal = () => {
  const { device } = uaParseResult
  if (!device || !device.model) {
    return defaultValue
  }
  return `${device.type} ${device.vendor} ${device.model} `
}

export const getDeviceName = () => {
  const { browser } = uaParseResult
  const os = uaParseResult.os || {}
  if (!browser || !browser.name) return defaultValue
  return `${browser.name} V${browser.version} (${os.name || ''})`
}

export const getTimezone = () => {
  const offset = new Date().getTimezoneOffset()
  let tz = -Math.floor(offset / 60)

  if (tz > 0) tz = `+${tz}`

  return `GMT${tz}`
}

export const getCanvas = canvasList => {
  const baseStr = canvasList[1].replace('canvas fp:data:image/png;base64,', '')
  const bin2hex = s => {
    let i
    let l
    let o = ''
    let n

    s += ''
    for (i = 0, l = s.length; i < l; i++) {
      n = s.charCodeAt(i).toString(16)
      o += n.length < 2 ? `0${n}` : n
    }
    return o
  }

  const bin = atob(baseStr)
  const crc = bin2hex(bin.slice(-16, -12))
  return crc
}

export const getWebglVendorAndRenderer = webgl => {
  const result = {}
  const len = webgl.length
  let cnt = 0

  for (let i = 0; i < len; i++) {
    const item = webgl[i] || ''
    if (item.indexOf('webgl unmasked vendor:') > -1) {
      // eslint-disable-next-line prefer-destructuring
      result.vendor = item.split('webgl unmasked vendor:')[1]
      cnt += 1
    } else if (item.indexOf('webgl unmasked renderer:') > -1) {
      // eslint-disable-next-line prefer-destructuring
      result.renderer = item.split('webgl unmasked renderer:')[1]
      cnt += 1
    }
    if (cnt === 2) break
  }

  return result
}

export const getPlugins = plugins => {
  const result = []

  plugins.forEach(plugin => {
    result.push(plugin[0])
  })
  return result.join(',')
}
